import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  Table,
  Button,
  Card,
  CardTitle,
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
  Input,
  Row,
  Col,
} from "reactstrap";
import {
  AGENCY_DELETE,
  AGENCY_DOCUMENT_DELETE_URL,
  REQUESTLIST_URL,
  REQUEST_STATUS_CHANGE,
  USER_DELETE_AGENCY_LIST,
} from "../../../utils/APIEndpoints";
import {
  authHeader,
  loggedUserDetails,
} from "../../../utils/functions/CoreFunctions";
import API from "../../../redux/actions/API";
import {
  getAlert,
  SingleStringFirstLetterCaps,
  amountFormat,
  getAlertToast,
  getCurrentUserId,
  getConfirm,
} from "../../../utils/functions/CustomFunctions";
import CustomViewButton from "../../common/CustomViewButton";
import CustomTableLoader from "../../common/CustomTableLoader";
import CustomTableEmptyRecord from "../../common/CustomTableEmptyRecord";
import CustomTableHeader from "../../common/CustomTableHeader";
import Swal from "sweetalert2";
import Pagination from "react-js-pagination";
import { debounce } from "underscore";
import { Link } from "react-router-dom";
import CustomDeleteButton from "../../common/CustomDeleteButton";
import Checkbox from "react-custom-checkbox";
import * as Icon from "react-icons/fi";

//Table Columns
const tableColumns = [
  { title: "Agency Name" },
  { title: "Document Name" },
  { title: "Hyperlink" },
  { title: "Status" },
  { title: "Fee" },
  { title: "Update Status" },
  { title: "Actions" },
];

const AdminRequests = (props) => {
  const { agencyId } = loggedUserDetails();
  //State
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdownOpenId, setDropdownOpenId] = useState(0);
  const [selected, setSelected] = useState([]);
  const [selectedlist, setSelectedlist] = useState(false);
  const [agencyList, setAgencyList] = useState([]);
  const [filter, setFilter] = useState({
    companyName: "",
    serviceName: "",
    status: "",
    count: 10,
  });
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const filterToggle = () => {
    setIsFilterOpen(!isFilterOpen);
  };
  //Debounce
  const delayedQuery = useRef(
    debounce(
      (filter) =>
        getGridData({
          ...filter,
          offset: currentPage,
        }),
      500
    )
  ).current;

  //Onchange filter
  const changeFilterField = ({ target: { name, value } }) => {
    setFilter({ ...filter, [name]: value });
  };

  const handleReset = () => {
    setFilter((val) => ({
      ...val,
      companyName: "",
      serviceName: "",
      status: "",
    }));
  };

  const onPageChanged = (page) => {
    setCurrentPage(page - 1);
    getGridData({
      ...filter,
      offset: page - 1,
    });
  };

  const toggle = (id) => {
    if (dropdownOpenId == id) {
      setDropdownOpenId(0);
    } else {
      setDropdownOpenId(id);
    }
  };

  const handlePageClick = (e, index) => {
    e.preventDefault();
    setCurrentPage(index);
  };

  //Get Grid Data
  const getGridData = async (queryParams) => {
    console.log("hellokavi", authHeader());
    try {
      setLoading(true);
      const options = {
        method: "GET",
        url: REQUESTLIST_URL,
        headers: authHeader(),
        params: { ...queryParams, role: "PayGov Admin", isDeleted: false },
      };
      const response = await API(options);
      const { status, data: initialResponse = [], totalCount } = response.data;
      if (status === "Success") {
        setTotalRecords(totalCount);
        let dataToDis = initialResponse.map((record) => {
          let { accountHolderName, serviceAmount } = record;
          let formattedData = {
            accountHolderName: SingleStringFirstLetterCaps(accountHolderName),
            serviceAmount:
              serviceAmount == 0 ? " - " : amountFormat(serviceAmount),
          };
          let dataToReturn = { ...record, ...formattedData };
          return dataToReturn;
        });
        setGridData(dataToDis);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        getAlert("error", data.message);
      }
    } finally {
      setLoading(false);
    }
  };
  const removeRecord = (event) => {
    const agencyServiceId = event.currentTarget.dataset.agency_service_id;
    Swal.fire(
      getConfirm("warning", "Are you sure you want to remove this document?")
    ).then(async (result) => {
      if (result.value) {
        try {
          setLoading(true);
          const options = {
            method: "DELETE",
            url: AGENCY_DOCUMENT_DELETE_URL,
            headers: authHeader(),
            // params: { agencyId: 0, agencyServiceId },
            params: { agencyServiceId },
          };
          const response = await API(options);
          const { status } = response.data;
          if (status === "Success") {
            getGridData({
              ...filter,
              // count: rowsPerPage || undefined,
              offset: currentPage,
              // agencyId: parseInt(agencyId),
              isDeleted: false,
            });
            Swal.fire(getAlertToast("success", "Record removed successfully"));
          }
        } catch (error) {
          if (error.response) {
            let { data } = error.response;
            Swal.fire(getAlertToast("error", data.message));
          }
        } finally {
          setLoading(false);
        }
      }
    });
  };
  //delete Multiple record
  const deleteRecord = async () => {
    Swal.fire(
      getConfirm(
        "warning",
        "Documents and Users will be deleted  regarding to this agency Are you sure you want to continue?"
      )
    ).then((result) => {
      if (result.value) {
        deleteAdmin();
      }
    });
  };

  const deleteAdmin = async (event, agencyServiceId) => {
    // const agencyServiceId = event.currentTarget.dataset.agency_service_id;

    let values = [];
    selected.forEach((value) => {
      values.push({
        // agencyId: 0,
        agencyServiceId: value,
      });
    });
    console.log(values);
    try {
      setLoading(true);
      const option = {
        method: "DELETE",
        url: USER_DELETE_AGENCY_LIST,
        headers: authHeader(),
        data: { agencyId: 0, agencyList: values },
      };
      const response = await API(option);
      const { status } = response.data;
      if (status == "Success") {
        getGridData({
          ...filter,
          count: rowsPerPage || undefined,
          offset: currentPage,
          isDeleted: false,
        });
      }

      console.log(selected);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };
  const checkvalues = (e, agency) => {
    console.log(e);
    //console.log(agency)
    if (e == true) {
      selected.push(agency);
      setSelected([...selected], selected);
    } else {
      selected.shift(agency);
      setSelected([...selected], selected);
    }
  };
  const statusChange = async (status, e) => {
    setLoading(true);
    const options = {
      method: "PUT",
      url: REQUEST_STATUS_CHANGE,
      headers: authHeader(),
      data: {
        agencyServiceId: dropdownOpenId,
        status: status,
        approvedBy: getCurrentUserId(),
      },
    };
    try {
      const response = await API(options);
      const { status, message } = response.data;
      if (status === "Success") {
        Swal.fire(getAlertToast("success", message));
        getGridData({
          ...filter,
          count: rowsPerPage || undefined,
          offset: currentPage,
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  const onChangeChecked = (e) => {
    console.log(e);
    let list = [];
    list.length = 0;
    if (selectedlist == false || e == true) {
      setSelectedlist(true);
      console.log("hellllo", gridData);
      gridData.filter((record) => {
        selected.push(record.agencyServiceId);
      });
      setSelected(selected);
    } else {
      setSelectedlist(false);

      gridData.map((record) => {
        selected.shift(record.agencyServiceId);
      });
      list.splice(0, selected.length);
      console.log(list);
      setSelected(list);
    }
  };
  const handleRowPerPage = ({ target: { name, value } }) => {
    setCurrentPage(0);
    setFilter((va) => ({ ...va, [name]: value || undefined }));
  };

  useEffect(() => {
    delayedQuery(filter);
  }, [filter]);

  const { companyName, serviceName, status } = filter;

  return (
    <div>
      <Card body className="mt-5">
        <div className="tableTitleBg mb-4">
          <CardTitle> Document Requests </CardTitle>
          <i
            className="fas fa-filter"
            style={{
              float: "right",
              margin: "0px 7px 3px 16px",
              fontSize: "19px",
              cursor: "pointer",
            }}
            onClick={filterToggle}
          ></i>
          {selected.length > 0 ? (
            <CustomDeleteButton
              // data-agency_service_id={agencyServiceId}
              onClick={deleteRecord}
            />
          ) : (
            ""
          )}
        </div>
        {isFilterOpen && (
          <Row form className="mb-4">
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  name="companyName"
                  placeholder="Agency Name"
                  onChange={changeFilterField}
                  value={companyName}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  name="serviceName"
                  placeholder="Document Name"
                  onChange={changeFilterField}
                  value={serviceName}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Input
                  type="select"
                  name="status"
                  placeholder="Status"
                  onChange={changeFilterField}
                  value={status}
                >
                  <option value={""}>----- Show All Status ----</option>
                  <option value={"Pending"}>Waiting for Approval</option>
                  <option value={"Accepted"}>Accepted</option>
                  <option value={"Rejected"}>Rejected</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md={2}>
              <div style={{ marginTop: "4px" }}>
                <Button color="danger" onClick={handleReset}>
                  Reset
                </Button>
              </div>
            </Col>
          </Row>
        )}
        <Table responsive hover>
          <thead style={{ backgroundColor: "#eee" }}>
            <tr>
              <th>
                {
                  <Checkbox
                    icon={<Icon.FiCheck color="#174A41" size={14} />}
                    borderColor="#D7C629"
                    checked={selectedlist}
                    onChange={onChangeChecked}
                    style={{ cursor: "pointer" }}
                  />
                }
              </th>

              {tableColumns.map(({ title }, key) => (
                <th key={`head_list_${key}`}>{title}</th>
              ))}
            </tr>
          </thead>
          {/* Table Header */}
          {/* <CustomTableHeader tableColumns={tableColumns} /> */}

          <tbody>
            {loading ? (
              // Table Loader
              <CustomTableLoader columnsCount={tableColumns.length} />
            ) : (
              // Table Loader
              <Fragment>
                {!gridData.length ? (
                  //  Empty Record
                  <>
                    <CustomTableEmptyRecord
                      columnsCount={tableColumns.length}
                    />
                  </>
                ) : (
                  //  Empty Record
                  <Fragment>
                    {gridData.map((record, key) => (
                      <tr key={`record_key_${key}`}>
                        <td>
                          {
                            <Checkbox
                              icon={<Icon.FiCheck color="#174A41" size={14} />}
                              borderColor="#D7C629"
                              style={{ cursor: "pointer" }}
                              //checked={active}
                              checked={selectedlist}
                              onChange={(e) =>
                                checkvalues(e, record.agencyServiceId)
                              }
                            />
                          }
                        </td>
                        <td>{record.companyName}</td>
                        <td>{record.serviceName}</td>
                        <td>
                          <Link
                            target="_blank"
                            to={`/preview-document/${record.serviceDomainURL}`}
                          >
                            {record.serviceDomainURL}
                          </Link>
                        </td>
                        <td>
                          {record.status === "Pending" ? (
                            <Badge color="warning">Waiting for Approval</Badge>
                          ) : record.status === "Accepted" ? (
                            <Badge color="success">{record.status}</Badge>
                          ) : (
                            <Badge color="danger">{record.status}</Badge>
                          )}
                        </td>
                        <td>{record.serviceAmount}‎</td>
                        <td>
                          {record.status !== "Rejected" ? (
                            <Dropdown
                              color="info"
                              className="f-l"
                              isOpen={record.agencyServiceId === dropdownOpenId}
                              toggle={(e) => toggle(record.agencyServiceId, e)}
                            >
                              <DropdownToggle caret>Status</DropdownToggle>
                              <DropdownMenu>
                                {record.status === "Pending" && (
                                  <DropdownItem
                                    onClick={(e) => statusChange("Accepted", e)}
                                  >
                                    Accept
                                  </DropdownItem>
                                )}
                                <DropdownItem
                                  onClick={(e) => statusChange("Rejected", e)}
                                >
                                  Reject
                                </DropdownItem>
                              </DropdownMenu>
                            </Dropdown>
                          ) : (
                            ""
                          )}
                        </td>
                        <td>
                          {/* Custom View Button  */}
                          <Link
                            target="_blank"
                            to={`/preview-document/${record.serviceDomainURL}`}
                          >
                            <CustomViewButton keyvalue={key} />
                          </Link>
                          <CustomDeleteButton
                            keyvalue={key}
                            data-agency_service_id={record.agencyServiceId}
                            onClick={removeRecord}
                          />
                          {/* Custom View Button  */}
                        </td>
                      </tr>
                    ))}
                  </Fragment>
                )}
              </Fragment>
            )}
          </tbody>
          {/* Table Body */}
        </Table>
        {gridData.length ? (
          <div className="d-flex py-4 justify-content-end space_between">
            <div className="space_between">
              <div>
                <p className="per_page">Records/Page</p>
              </div>
              <div>
                <FormGroup>
                  <Input
                    className="pagi_drop"
                    type="select"
                    name="count"
                    onChange={handleRowPerPage}
                    value={filter.count}
                  >
                    <option value={""}>Show All</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Input>
                </FormGroup>
              </div>
            </div>
            {filter.count && (
              <div>
                <Pagination
                  itemClass="page-item"
                  linkClass="page-link"
                  activePage={currentPage + 1}
                  itemsCountPerPage={filter.count}
                  totalItemsCount={totalRecords}
                  onChange={onPageChanged}
                />
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </Card>
    </div>
  );
};

export default AdminRequests;
